<template>
  <el-dialog
      :visible.sync="dialogVisible"
      width="32%"
      :show-close="false"
  >
    <div class="custom-dialog-header" slot="title">
      <span>删除租户</span>
      <i class="el-icon-close custom-close-button" @click="handleCancel"></i>
    </div>
    <el-divider class="line"/>
    <div class="passInfo" v-show="isShow === 1">
      <div class="passInfo-warn">
        确定要删除该租户吗，该租户的账户信息、房间关联关系将一并删除，如要退租请前往账单管理-销户退租，<span style="color: #fd4339">此操作不可逆，请谨慎操作。</span></div>
      请输入密码， 确认此操作
    </div>
    <div class="passInfo" v-show="isShow === 2">
      <div class="passInfo-warn">
        系统检测到该租户还有未结清的费用，共计¥{{ tenement.totalBalance }}元，请下载电费明细单，与租户确认费用，再进行此操作。<span style="color: #fd4339">此操作不可逆，请谨慎操作。</span>
      </div>
      请输入密码， 确认此操作
    </div>
    <div class="passInput" v-show="isShow === 1 || isShow === 2">
      <div class="input-box row-center">
        <div class="code-item" :class="codeValue.length == 0 && inputFocus ? 'code-item-active' : ''">
          {{ codeValue[0] | filterVal }}
        </div>
        <div class="code-item" :class="codeValue.length == 1 && inputFocus ? 'code-item-active' : ''">
          {{ codeValue[1]| filterVal }}
        </div>
        <div class="code-item" :class="codeValue.length == 2 && inputFocus ? 'code-item-active' : ''">
          {{ codeValue[2]| filterVal }}
        </div>
        <div class="code-item" :class="codeValue.length == 3 && inputFocus ? 'code-item-active' : ''">
          {{ codeValue[3]| filterVal }}
        </div>
        <el-input class="input-code"
                  :value="codeValue"
                  :maxlength="4"
                  @blur="codeInputBlur"
                  @focus="codeInputFocus"
                  @input="codeInputChange">
        </el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer" v-show="isShow === 1 || isShow === 2">
        <el-button style="width: 20%; margin-right: 30rem" @click="handleCancel" round>取 消</el-button>
        <el-button v-show="isShow === 1" style="width: 20%" type="primary" @click="handleOk('one')"
                   round>确 定</el-button>
        <el-button v-show="isShow === 2" style="width: 20%" type="primary" @click="handleOk('twice')"
                   round>确 定</el-button>
      <div style="width: 50rem; height: 20rem"></div>
    </span>
  </el-dialog>
</template>

<script>
import {
  GET_V3_Cost_Room_Valid_Password,
  PUT_V3_Cost_Enterprise_Renting_Out,
  POST_V3_Cost_Enterprise_Delete
} from '@/api/billing.js'

export default {
  name: "dialogManage",
  data() {
    return {
      dialogVisible: false,
      codeValue: '',
      inputFocus: false,
      isShow: 1,
      // 租户数据
      tenement: {}
    }
  },
  props: ['getInit'],
  filters: {
    filterVal(value) {
      if (value) {
        return '*';
      }
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },

    // 密码验证
    async handlePass(val) {
      const {data} = await GET_V3_Cost_Room_Valid_Password({
        password: val
      })
      return data
    },

    async handleOk(type) {
      switch (type) {
        case 'one':
          if (this.codeValue.length === 0) {
            this.$message({
              message: '请输入密码！',
              type: 'warning'
            });
          } else if (this.codeValue.length < 4 && this.codeValue.length > 0) {
            this.$message({
              message: '请输入完整密码！',
              type: 'warning'
            });
          } else {
            const data = await this.handlePass(this.codeValue)
            // console.log(data)
            if (data.data == true) {
              // 密码输入成功 判断用户是否欠费
              if (this.tenement.totalBalance < 0) {
                this.isShow = 2
                this.codeValue = ''
              } else {
                await this.delete()
              }
            } else {
              this.codeValue = ''
              this.$message.error('密码输入错误，请重新输入！')
            }
          }
          ;
          break
        case 'twice':
          if (this.codeValue.length === 0) {
            this.$message({
              message: '请输入密码！',
              type: 'warning'
            });
          } else if (this.codeValue.length < 4 && this.codeValue.length > 0) {
            this.$message({
              message: '请输入完整密码！',
              type: 'warning'
            });
          } else {
            const data = await this.handlePass(this.codeValue)
            // console.log(data)
            if (data.data == true) {
              // console.log(this.tenement)
              // 密码输入成功 调用删除租户接口，删除成功
              await this.delete()
              // const data1 = await POST_V3_Cost_Enterprise_Delete(this.tenement.id)
              // if (data1.data.code === 200) {
              //   this.$message.success('删除成功！')
              //   this.$emit('getInit')
              //   this.dialogVisible = false
              // } else {
              //   this.$message.error('删除失败!')
              // }
            } else {
              this.codeValue = ''
              this.$message.error('密码输入错误，请重新输入！')
            }
          }
          break
        default:
          return
      }
    },

    async delete() {
      const data1 = await POST_V3_Cost_Enterprise_Delete(this.tenement.id)
      if (data1.data.code === 200) {
        this.$message.success('删除成功！')
        this.$emit('getInit')
        this.dialogVisible = false
      } else {
        this.$message.error('删除失败!')
      }
    },

    // 验证码输入框失去焦点
    codeInputBlur() {
      this.inputFocus = false;
    },

    // 验证码输入框获取到焦点
    codeInputFocus() {
      this.inputFocus = true;
    },

    // 验证码输入框
    codeInputChange(e) {
      if (e) {
        // 判断输入内容是否为数字
        if ((/^\+?[0-9][0-9]*$/).test(e)) {
          this.codeValue = e;
        }
      } else {
        this.codeValue = '';
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.codeValue = ''
        this.isShow = 1
      }
    }

  }
}
</script>

<style scoped lang="less">
.custom-dialog-header {
  width: 93%;
  padding: 0;
  font-size: 24rem;
  position: absolute;
  top: 16rem;
  left: 24rem;
  //background-color: pink;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .custom-close-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    //font-size: 24rem;

    &:hover {
      color: #409eff;
    }
  }
}

.line {
  position: absolute;
  left: 0;
  top: 35rem;
}

.passInfo {
  text-align: center;
  color: #666;
  font-size: 18rem;
  margin-top: 20rem;

  .passInfo-warn {
    width: 93%;
    color: #333;
    margin: 0 auto 30rem;
    text-align: left;
  }
}

.passInput {
  display: flex;
  justify-content: space-around;
  margin-bottom: 30rem;

  .passInput-item {
    width: 12%;
    border-bottom: 1px solid #666;
    text-align: center;
  }

  /deep/ .el-input {
    width: 100%;
  }

  /deep/ .el-input__inner {
    border: none;
  }

  .input-box {
    margin-top: 10px;
    position: relative;
  }

  .input-code {
    position: absolute;
    left: 0;
    opacity: 0;
  }

  .code-item {
    width: 75px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-bottom: 2px solid #999999;
    margin: 0 20px;
    display: inline-block;
  }

  .code-item-active {
    border-color: #0D94FF;
    //border-bottom: 2px solid #0D94FF;
  }

  // 隐藏input
  .input-box {
    .el-input__inner {
      width: 362px;
      height: 50px;
      background-color: transparent;
      border: none;
      color: transparent;
    }
  }
}

.success {
  text-align: center;
  padding: 0 50rem;

  .success-img {
    width: 65rem;
    height: 65rem;
    margin-bottom: 10rem;
  }

  .success-text1 {
    font-size: 20rem;
  }

  .success-text2 {
    font-size: 15rem;
    color: #999;
    margin-bottom: 20rem;
  }

  .success-text3 {
    text-align: left;
    margin-top: 50rem;
    margin-bottom: 80rem;
  }
}

</style>